import h from 'hyperscript';
import { renderRouteLegend } from 'cadenza/map/legend/route-legend-renderer';
import { renderIsochroneLegend } from 'cadenza/map/legend/isochrone-legend-renderer';

const LEGEND_ELEMENT_RENDERERS_BY_TYPE = {
  ROUTE: renderRouteLegend,
  ISOCHRONE: renderIsochroneLegend
};

export function getRenderedLegendElementRow (layerLegendElement) {
  const rowElements = [];
  if (layerLegendElement.type !== 'default') {
    rowElements.push(...LEGEND_ELEMENT_RENDERERS_BY_TYPE[layerLegendElement.type.toUpperCase()](layerLegendElement));
  } else {
    if (layerLegendElement.imageAsBase64) {
      rowElements.push(h('img', { src: layerLegendElement.imageAsBase64 }));
    }
    if (layerLegendElement.title) {
      rowElements.push(h('span.title', layerLegendElement.title));
    }
  }
  return h('.layerLegendRow', rowElements);
}
